import { getWindow } from './browserVars';

const loadApi = new Promise((resolve, reject) => {
  const browserWindow = getWindow();
  if (browserWindow) {
    if (browserWindow.YT) {
      resolve(browserWindow.YT);
    } else {
      const fnId = browserWindow.setTimeout(
        () => {
          reject([
            'YouTube API took too long to load.',
            'Is the API added as part of the page scripts?',
          ].join('\n'));
        },
        6 * 1000
      );
      browserWindow.onYouTubeIframeAPIReady = () => {
        browserWindow.clearTimeout(fnId);
        delete browserWindow.onYouTubeIframeAPIReady;
        resolve(browserWindow.YT);
      };
    }
  }
});

export default loadApi;
